<template>
  <div>
    <a-card class="m-height-full m-display-flex flex-column">
      <div slot="title">
        <span>{{ this.id ? 'Edit' : 'Create' }} Salary Component</span>
      </div>
      <template slot="extra">
      </template>
      <a-spin
        :spinning="loading.page"
        tip="Preparing To Show Data ...  "
      >
        <div class="container-essential">
          <a-form :form="form">
            <a-row :gutter="16">
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-item label="Period">
                  <a-select
                    showSearch
                    v-decorator="['periode', { rules: [{ required: true }] }]"
                    :disabled="lock_header"
                  >
                    <a-select-option v-for="item in option.periode" :key="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="Description">
                  <a-input v-decorator="['description', { rules: [{ required: true }], initialValue: '' }]" :disabled="lock_header" autocomplete="false"/>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-item label="Insert From Previous Period">
                  <a-select
                    showSearch
                    allowClear
                    v-decorator="['prev_periode', { rules: [{ required: false }] }]"
                    :disabled="lock_header"
                  >
                    <a-select-option v-for="item in option.prev_periode" :key="item.periode">
                      {{ moment(item.periode,'YYYY-MM').format('MMMM YYYY') }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-divider class="margin-small"/>
            <a-row :gutter="16" type="flex" justify="end">
              <a-col>
                <a-button type="primary" class="margin-top" @click="handlegenerate" :loading="loading.preview" :disabled="lock_header">
                  Generate
                </a-button>
                <a-button v-if="lock_header" type="danger" class="margin-left" @click="handleReset" :loading="loading.reset">
                  Reset
                </a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table
          class="ccd margin-top"
          :columns="columns"
          :rowKey="(record, index) => {return index;}"
          :dataSource="dataSource.data"
          :pagination="pagination"
          size="small"
          :scroll="{ x: 2500, y: 400 }"
          bordered
        >
          <template slot="title">
            <a-row :gutter="16" type="flex" justify="space-between" align="middle">
              <a-col>
                <div class="title-table-top-left">Component Details</div>
              </a-col>
              <a-col>
                <div class="m-display-flex flex-col">
                  <div class="m-display-flex flex-col" style="align-content: center;">
                    <b style="align-content: center;">Filter by Color :&nbsp;&nbsp;&nbsp;</b>
                    <a-checkbox v-model="filterBG.putih" @change="onChangeWhiteCheck" class="m-display-flex flex-col" style="align-content: center;top:2px">
                      <div style="width:50px; background-color: white;border: 1px solid #d9d9d9;">&nbsp;</div>
                    </a-checkbox>
                    <a-checkbox v-model="filterBG.merah" @change="onChangeWhiteCheck" class="m-display-flex flex-col" style="align-content: center;top:2px">
                      <div style="width:50px; background-color: rgba(231, 76, 60, 0.35);border: 1px solid #d9d9d9;">&nbsp;</div>
                    </a-checkbox>
                  </div>
                  <a-input-search
                    v-model="search"
                    style="width: 200px;"
                    placeholder="Search ... "
                  />  
                </div>
              </a-col>
            </a-row>
          </template>
          <template slot="no" slot-scope="text, data, index">
            {{ pagination.current == 1 ? index+1 : ((pagination.current-1)*pagination.pageSize)+index+1 }}
          </template>
          <template slot="admin_bank" slot-scope="item">
            <div :class="item.admin_bank!=item.admin_bank_sebelum ? 'td_not_same':''">
              <CurrencyJustified
                currencyValue="IDR"
                :valueNumber="item.admin_bank"
              />
            </div>
          </template>
          <template slot="cop_perusahaan" slot-scope="item">
            <div :class="item.cop_perusahaan!=item.cop_perusahaan_sebelum ? 'td_not_same':''">
              <CurrencyJustified
                currencyValue="IDR"
                :valueNumber="item.cop_perusahaan"
              />
            </div>
          </template>
          <template slot="cop_karyawan" slot-scope="item">
            <div :class="item.cop_karyawan!=item.cop_karyawan_sebelum ? 'td_not_same':''">
              <CurrencyJustified
                currencyValue="IDR"
                :valueNumber="item.cop_karyawan"
              />
            </div>
          </template>
          <template slot="hutang_karyawan" slot-scope="item">
            <div :class="item.hutang_karyawan!=item.hutang_karyawan_sebelum ? 'td_not_same':''">
              <CurrencyJustified
                currencyValue="IDR"
                :valueNumber="item.hutang_karyawan"
              />
            </div>
          </template>
          <template slot="kesehatan_tambahan" slot-scope="item">
            <div :class="item.kesehatan_tambahan!=item.kesehatan_tambahan_sebelum ? 'td_not_same':''">
              <!-- <CurrencyJustified
                currencyValue="IDR"
                :valueNumber="item.kesehatan_tambahan"
              /> -->
              <div style="text-align: right;">{{ item.kesehatan_tambahan }}</div>
            </div>
          </template>
          <template slot="potongan_koperasi" slot-scope="item">
            <div :class="item.potongan_koperasi!=item.potongan_koperasi_sebelum ? 'td_not_same':''">
              <CurrencyJustified
                currencyValue="IDR"
                :valueNumber="item.potongan_koperasi"
              />
            </div>
          </template>
          <template slot="pimpro" slot-scope="item">
            <div :class="item.pimpro!=item.pimpro_sebelum ? 'td_not_same':''">
              <CurrencyJustified
                currencyValue="IDR"
                :valueNumber="item.pimpro"
              />
            </div>
          </template>
          <template slot="car" slot-scope="item">
            <div :class="item.car!=item.car_sebelum ? 'td_not_same':''">
              <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.car==1"/>
              <a-icon class="sts-c" type="close-square" v-else/>
            </div>
          </template>
          <template slot="inactive" slot-scope="item">
            <div :class="item.inactive!=item.inactive_sebelum ? 'td_not_same':''">
              <div style="text-align: right;">{{ item.inactive ? item.inactive : "0%" }}</div>
            </div>
          </template>
          <template slot="absensi" slot-scope="item">
            <div style="text-align: right;" :class="item.absensi!=item.absensi_sebelum ? 'td_not_same':''">
              {{ item.absensi?item.absensi:"0%" }}
            </div>
          </template>
          <template slot="makan" slot-scope="item">
            <div :class="item.makan!=item.makan_sebelum ? 'td_not_same':''">
              <CurrencyJustified
                currencyValue="IDR"
                :valueNumber="item.makan"
              />
            </div>
          </template>
          <!-- <template slot="kesehatan_karyawan" slot-scope="item">
            <a-checkbox v-model="item.kesehatan_karyawan" :checked="item.kesehatan_karyawan==1"></a-checkbox>
          </template> -->
          <template slot="jkk_perusahaan" slot-scope="item">
            <div :class="item.jkk_perusahaan!=item.jkk_perusahaan_sebelum ? 'td_not_same':''">
              <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jkk_perusahaan==1"/>
              <a-icon class="sts-c" type="close-square" v-else/>
            </div>
          </template>
          <template slot="jkm_perusahaan" slot-scope="item">
            <div :class="item.jkm_perusahaan!=item.jkm_perusahaan_sebelum ? 'td_not_same':''">
              <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jkm_perusahaan==1"/>
              <a-icon class="sts-c" type="close-square" v-else/>
            </div>
          </template>
          <template slot="jp_perusahaan" slot-scope="item">
            <div :class="item.jp_perusahaan!=item.jp_perusahaan_sebelum ? 'td_not_same':''">
              <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jp_perusahaan==1"/>
              <a-icon class="sts-c" type="close-square" v-else/>
            </div>
          </template>
          <template slot="jht_perusahaan" slot-scope="item">
            <div :class="item.jht_perusahaan!=item.jht_perusahaan_sebelum ? 'td_not_same':''">
              <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jht_perusahaan==1"/>
              <a-icon class="sts-c" type="close-square" v-else/>
            </div>
          </template>
          <template slot="kesehatan_karyawan" slot-scope="item">
            <div :class="item.kesehatan_karyawan!=item.kesehatan_karyawan_sebelum ? 'td_not_same':''">
              <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.kesehatan_karyawan==1"/>
              <a-icon class="sts-c" type="close-square" v-else/>
            </div>
          </template>
          <template slot="jp_karyawan" slot-scope="item">
            <div :class="item.jp_karyawan!=item.jp_karyawan_sebelum ? 'td_not_same':''">
              <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jp_karyawan==1"/>
              <a-icon class="sts-c" type="close-square" v-else/>
            </div>
          </template>
          <template slot="jht_karyawan" slot-scope="item">
            <div :class="item.jht_karyawan!=item.jht_karyawan_sebelum ? 'td_not_same':''">
              <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jht_karyawan==1"/>
              <a-icon class="sts-c" type="close-square" v-else/>
            </div>
          </template>

          <template slot="footer">
            <a-row :gutter="16">
              <a-col xs="{ span: 24 }" :lg="{ span: 12 }">
                <div><b><small>Color Desc:</small></b></div>
                <div style="display:flex;vertical-align: middle;margin-top:5px;margin-bottom:25px">
                  <div class="r_not_same" style="width:20px;height: 100%;">&nbsp;</div>
                  <small>&nbsp;has a different value from the previous period</small></div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                
              </a-col>
            </a-row>
          </template>
        </a-table>
        <a-card>
          <template slot="title">
            <div class="title-table-top-left">Action</div>
          </template>
          <div class="container-essential">
            <a-form-model ref="formApproval" :model="formApproval" :rules="rules">
              <a-row :gutter="16">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form-model-item :label="'Approval'+(dataSource.approval[0]?' ['+dataSource.approval[0].actor+']':' [-]')" prop="approval"></a-form-model-item>
                  <a-select v-model="formApproval.approval">
                    <a-select-option v-for="item in dataSource.approval" :key="item.tlc">{{item.nama}}</a-select-option> 
                  </a-select>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form-model-item :label="'Note'" prop="note">
                    <a-textarea
                      class="m-width-full"
                      autocomplete="off"
                      v-model="formApproval.note"
                    ></a-textarea>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
            <a-row :gutter="16" type="flex" justify="end" align="top">
              <a-col style="text-align: right;">
                <a-button type="primary" icon="save" class="margin-top" @click="handleSubmit" :loading="loading.submit" :disabled="!lock_header">Submit</a-button>
              </a-col>
            </a-row>
          </div>
        </a-card>
      </a-spin>
    </a-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";

moment.locale('en')

export default {
  name: "cop-deduction-create",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  props: ["id"],
  data(){
    return {
      loading: {
        preview: false,
        submit: false,
        page: false,
        reset: false
      },
      option: {
        periode : [],
        prev_periode: []
      },
      dataSource: {
        data: [],
        dataOriginal: [],
        dataEditOriginal: [],
        approval: [],
        approvalOri: []
      },
      search: "",
      lock_header: false,
      pagination: {
        onChange: (page) => {this.pagination.current = page;},
        pageSize: 50,
        current: 1,
        size: "small",
      },
      formApproval:{
        approval: null,
        note:""
      },
      rules:{
        approval: {
          required: true,
          message: "Approval is required!",
          trigger: "change",
        },
        note: {
          required: false,
          message: "Note is required!",
          trigger: "change",
        },
      },
      approval: [],
      filterBG:{
        putih: false,
        merah: false,
      }
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted(){
    this.fetchListPevComponent()
    if(this.id){
      this.fetchEditData()
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
    ]),
    columns(){
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: "60px",
          align: "right",
          fixed:"left",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "TLC",
          dataIndex: "tlc",
          key: "tlc",
          width: "100px",
          fixed:"left",
          align: "center",
        },
        {
          title: "Bank Admin",
          key: "admin_bank",
          width: "100px",
          align: "center",
          scopedSlots: { customRender: "admin_bank" },
        },
        {
          title: "COP Company",
          key: "cop_perusahaan",
          width: "170px",
          scopedSlots: { customRender: "cop_perusahaan" },
        },
        {
          title: "COP Employee",
          key: "cop_karyawan",
          width: "170px",
          scopedSlots: { customRender: "cop_karyawan" },
        },
        {
          title: "Employee Debt",
          key: "hutang_karyawan",
          scopedSlots: { customRender: "hutang_karyawan" },
        },
        {
          title: "Health Additional",
          key: "kesehatan_tambahan",
          scopedSlots: { customRender: "kesehatan_tambahan" },
        },
        {
          title: "Cooperative Deduction",
          key: "potongan_koperasi",
          scopedSlots: { customRender: "potongan_koperasi" },
        },
        {
          title: "Project Leader",
          key: "pimpro",
          scopedSlots: { customRender: "pimpro" },
        },
        {
          title: "Car",
          key: "car",
          align:"center",
          scopedSlots: { customRender: "car" },
        },
        {
          title: "Active Days",
          key: "inactive",
          scopedSlots: { customRender: "inactive" },
        },
        {
          title: "Attendence",
          key: "absensi",
          scopedSlots: { customRender: "absensi" },
        },
        {
          title: "meal allowances",
          key: "makan",
          scopedSlots: { customRender: "makan" },
        },
        // {
        //   title: "health benefits",
        //   key: "kesehatan_karyawan",
        //   align: "center",
        //   scopedSlots: { customRender: "kesehatan_karyawan" },
        // },
        {
          title: "JKK Company",
          key: "jkk_perusahaan",
          align: "center",
          scopedSlots: { customRender: "jkk_perusahaan" },
        },
        {
          title: "JKM Company",
          key: "jkm_perusahaan",
          align: "center",
          scopedSlots: { customRender: "jkm_perusahaan" },
        },
        {
          title: "JP Company",
          key: "jp_perusahaan",
          align: "center",
          scopedSlots: { customRender: "jp_perusahaan" },
        },
        {
          title: "JHT Company",
          key: "jht_perusahaan",
          align: "center",
          scopedSlots: { customRender: "jht_perusahaan" },
        },
        {
          title: "Healt Benefit",
          key: "kesehatan_karyawan",
          align: "center",
          scopedSlots: { customRender: "kesehatan_karyawan" },
        },
        {
          title: "JP Employee",
          key: "jp_karyawan",
          align: "center",
          scopedSlots: { customRender: "jp_karyawan" },
        },
        {
          title: "JHT Employee",
          key: "jht_karyawan",
          align: "center",
          scopedSlots: { customRender: "jht_karyawan" },
        },
      ]
        return kolom
    }
  },
  methods:{
    moment,
    onSearch(){

    },
    handlegenerate(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }
        
        let data = new FormData();
        if(this.id)
          data.append("id_payment", this.id);
        data.append("periode", values.periode);
        if(values.prev_periode)
          data.append("from_periode", values.prev_periode);
        data.append("description", values.description);

        this.loading.preview = true
        this.asyncAxiosPost(
          "komponen_gaji/generate",
          "formdata",
          this.getAuth,
          data
        )
        .then((response) => {
          this.dataSource.data = response.dtl
          this.dataSource.dataOriginal = this.dataSource.data
          this.dataSource.approval = response.approval

          this.formApproval.approval = this.dataSource.approval[0].tlc

          this.lock_header = true
          this.loading.preview = false
        })
        .catch(() => {
          this.loading.preview = false
        });
      })
    },
    generateOption(){
      let thn = [moment().format('YYYY'), moment().subtract(1, 'year').format('YYYY')]
      for (let index = 0; index < thn.length; index++) {
        for (let index2 = 0; index2 < 12; index2++) {
          let valDT = moment().set('year', thn[index]).set('month', 11-index2).format('YYYY-MM')

          let isexist = this.option.prev_periode.filter(item => item.periode==valDT)
          if(isexist.length==0){
            this.option.periode.push({
              value: valDT,
              label: moment().set('year', thn[index]).set('month', 11-index2).format('MMMM YYYY')
            })
          }
        }
      }
      
    },
    handleSubmit(){
      const that = this;
      let title = "";
      title = "Are you sure to Submit this data?";
      that.$confirm({
        title: title,
        content: "Yes / No?",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.form.validateFields((err, values) => {
            if (err) {
              that.displayMessage("choose-action");
              return;
            }
            
            let data = new FormData();
            if(that.id)
              data.append("id_komponen", that.id);
            data.append("periode", values.periode);
            if(values.prev_periode)
              data.append("periode", values.prev_periode);
            data.append("description", values.description);
            data.append("note", that.formApproval.note?that.formApproval.note:'');

            that.loading.submit = true
            that.asyncAxiosPost(
              "komponen_gaji",
              "formdata",
              that.getAuth,
              data
            )
            .then(() => {
              that.displayMessage("success-save")
              that.$router.push({ name: "salary-component-list-hrd" });
            })
            .catch(() => {
              that.loading.submit = false
            });
          })
        },
        onCancel() {},
      })
    },
    async handleReset(){
      this.loading.reset = true
      if(this.id){
        this.dataSource.data = this.dataSource.dataEditOriginal.dtl
        this.dataSource.dataOriginal = this.dataSource.dataEditOriginal.dtl
        this.dataSource.approval = this.dataSource.approvalOri
        this.lock_header = false
      }else{
        this.dataSource.data = []
        this.dataSource.dataOriginal = []
        this.dataSource.approval = []
        this.lock_header = false
      }
      this.loading.reset = false
    },
    fetchListPevComponent(){
      this.asyncAxiosGet("komponen_gaji",
        this.getAuth,
        {}
      )
      .then(async (response) => {
        this.option.prev_periode = response.data
        this.generateOption()
      })
    },
    fetchEditData(){
      this.loading.page = true
      this.asyncAxiosGet("komponen_gaji",
        this.getAuth,
        {id_komponen: this.id}
      )
      .then(async (response) => {
        this.dataSource.dataEditOriginal = response
        this.dataSource.data = response.dtl
        this.dataSource.dataOriginal = this.dataSource.data
        
        this.$nextTick(function () {
          this.form.setFieldsValue({
            periode: this.dataSource.dataEditOriginal.header.periode,
            description: this.dataSource.dataEditOriginal.header.deskripsi,
          });
        })

        this.lock_header = false
        this.loading.page = false
      })
      .catch((err) => {
        console.log(err);
      });
    },
    onChangeWhiteCheck(){
      this.filterWarna(this.search)
    },
    filterWarna(val){
      if(val){ 
        this.dataSource.data = this.dataSource.dataOriginal.filter(item => item.tlc.toLowerCase().indexOf(val.toLowerCase()) >=0 )
      }else{
        this.dataSource.data = this.dataSource.dataOriginal
      }

      if(this.filterBG.putih){
        this.dataSource.data = this.dataSource.data.filter(
          item => item.absensi==item.absensi_sebelum &&
                  item.admin_bank==item.admin_bank_sebelum && 
                  item.cop_perusahaan==item.cop_perusahaan_sebelum &&
                  item.cop_karyawan==item.cop_karyawan_sebelum &&
                  item.hutang_karyawan==item.hutang_karyawan_sebelum &&
                  item.inactive==item.inactive_sebelum &&
                  item.jht_karyawan==item.jht_karyawan_sebelum &&
                  item.jht_perusahaan==item.jht_perusahaan_sebelum &&
                  item.jkk_perusahaan==item.jkk_perusahaan_sebelum &&
                  item.jkm_perusahaan==item.jkm_perusahaan_sebelum &&
                  item.jp_karyawan==item.jp_karyawan_sebelum &&
                  item.jp_perusahaan==item.jp_perusahaan_sebelum &&
                  item.kesehatan_karyawan==item.kesehatan_karyawan_sebelum &&
                  item.kesehatan_perusahaan==item.kesehatan_perusahaan_sebelum &&
                  item.kesehatan_tambahan==item.kesehatan_tambahan_sebelum &&
                  item.makan==item.makan_sebelum &&
                  item.mobil==item.mobil_sebelum &&
                  item.pimpro==item.pimpro_sebelum &&
                  item.potongan_koperasi==item.potongan_koperasi_sebelum
        )
      }

      if(this.filterBG.merah){
        this.dataSource.data = this.dataSource.data.filter(
          item => item.absensi!=item.absensi_sebelum ||
                  item.admin_bank!=item.admin_bank_sebelum || 
                  item.cop_perusahaan!=item.cop_perusahaan_sebelum ||
                  item.cop_karyawan!=item.cop_karyawan_sebelum ||
                  item.hutang_karyawan!=item.hutang_karyawan_sebelum ||
                  item.inactive!=item.inactive_sebelum ||
                  item.jht_karyawan!=item.jht_karyawan_sebelum ||
                  item.jht_perusahaan!=item.jht_perusahaan_sebelum ||
                  item.jkk_perusahaan!=item.jkk_perusahaan_sebelum ||
                  item.jkm_perusahaan!=item.jkm_perusahaan_sebelum ||
                  item.jp_karyawan!=item.jp_karyawan_sebelum ||
                  item.jp_perusahaan!=item.jp_perusahaan_sebelum ||
                  item.kesehatan_karyawan!=item.kesehatan_karyawan_sebelum ||
                  item.kesehatan_perusahaan!=item.kesehatan_perusahaan_sebelum ||
                  item.kesehatan_tambahan!=item.kesehatan_tambahan_sebelum ||
                  item.makan!=item.makan_sebelum ||
                  item.mobil!=item.mobil_sebelum ||
                  item.pimpro!=item.pimpro_sebelum ||
                  item.potongan_koperasi!=item.potongan_koperasi_sebelum
        )
      }
    }
  },
  watch:{
    "search"(val){
      this.filterWarna(val)
    }
  }
}
</script>
<style lang="less" scoped>
.ccd:deep{
  .ant-table-content{
    thead {
      th {
        text-transform: uppercase;
        text-align: center;
      }
    }
  }

  .title-table-top-left{
    font-weight: 500;
    font-size: 16px;
    color: @color-secondary;
  }
}
</style>
<style lang="less">
  .r_same { 
    background-color: fade(@color-secondary, 35%)!important;
  }

  .r_not_same { 
    background-color: fade(@color-primary, 35%)!important;
  }

  td:has(.td_not_same) {
    background-color: fade(@color-primary, 35%)!important;
  }

  .sts-c{
    font-size: large;
  }
</style>